<yat-icon
  name="copy"
  class="copy-to-clipboard-icon"
  [class.isCopying]="isCopying"
  (click)="copyToClipboard()"
  [yatTooltip]="(tooltipText | async) ?? ''"
  [manualTooltip]="true"></yat-icon>
